require('./dist/v-accordion');
module.exports = 'vAccordion';



//////////////////
// WEBPACK FOOTER
// ./~/v-accordion/index.js
// module id = 1246
// module chunks = 1